import { CrudService } from './crud.service';

export interface CacheKeysResponse {
  keys: string[];
  cursor: string;
  hasMore: boolean;
}

export interface DeleteCacheKeysResponse {
  success: boolean;
  count: number;
}

export class CacheAdminService {
  private readonly crudService: CrudService;

  constructor() {
    this.crudService = new CrudService('api/admin/cache');
  }

  public async getKeys(pattern = '*', cursor = '0', limit = 100): Promise<CacheKeysResponse> {
    const queryParams = new URLSearchParams();
    queryParams.set('pattern', pattern);
    queryParams.set('cursor', cursor);
    queryParams.set('limit', String(limit));

    const result = await this.crudService.do('get', `keys?${queryParams}`);

    return result.model ?? { keys: [], cursor: '0', hasMore: false };
  }

  public async deleteKeys(keys: string[]): Promise<DeleteCacheKeysResponse> {
    const result = await this.crudService.do('post', 'delete', { keys });

    return result.model ?? { success: false, count: 0 };
  }

  public async clearAll(): Promise<{ success: boolean }> {
    const result = await this.crudService.do('post', 'clear');

    return result.model ?? { success: false };
  }
}
